import { Injectable } from '@angular/core';
import { AuthRedirectService, RoutingService, AuthRedirectStorageService, AuthFlowRoutesService } from '@spartacus/core';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root',
})
export class CustomAuthRedirectService extends AuthRedirectService {
  constructor(
    protected override routing: RoutingService,
    protected override router: Router,
    protected override authRedirectStorageService: AuthRedirectStorageService,
    protected override authFlowRoutesService: AuthFlowRoutesService
  ) {
    super(routing, router, authRedirectStorageService, authFlowRoutesService);
  }

  override redirect(): void {
    this.router.navigateByUrl('/my-account/dashboard');
  }
}
